export default __webpack_public_path__ + "static/Крысиные бега_25-03ec5c25beac67c47aaa3a201f5c19c8.jpg";